"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionSetStatusCtrl = void 0;
var i18n_1 = require("../../i18n");
var index_1 = require("../../services/index");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var collection_status_modal_1 = require("../collection.status.modal/collection.status.modal");
exports.CollectionSetStatusCtrl = {
    // if at least one selected collection's form has state metadata and the user is neither Viewer nor Downloader
    canDisplay: function () {
        var userProfile = index_1.Services.UserProfile.get(index_1.Services.User.current.objectId);
        if (!index_1.Services.UserProfile.isDepartmentViewer(userProfile) && !index_1.Services.UserProfile.isDepartmentDownloader(userProfile)) {
            for (var _i = 0, _a = page_state_1.CurrentState.Tag.collections; _i < _a.length; _i++) {
                var summary = _a[_i];
                var formSummary = store_1.AppStore.FormSummary.get(summary.formRevision);
                if (formSummary != null && formSummary.metadata != null && formSummary.metadata.status != null) {
                    return true;
                }
            }
        }
        return false;
    },
    canSetStatus: function () {
        if (!exports.CollectionSetStatusCtrl.canDisplay()) {
            return false;
        }
        return true;
    },
    showSetStatusModal: function () {
        var collections = page_state_1.CurrentState.Tag.collections;
        var modal = new collection_status_modal_1.CollectionStatusModal({
            title: i18n_1.T.COLLECTION_STATUS_TITLE,
            confirm: function () { return modal.statusSelector.inputState.value ? i18n_1.T.COLLECTION_STATUS : i18n_1.T.CLEAR_COLLECTION_STATUS; },
            success: {
                key: i18n_1.T.COLLECTION_STATUS_SUCCESS,
                attrs: {
                    count: collections.length
                }
            }
        }, collections);
        modal.open();
    }
};
//# sourceMappingURL=collection.status.ctrl.js.map